module.exports = __webpack_public_path__ + "img/shipping-and-delivery.f4cb4af7.png";